<template>
  <div class="section">
    <div class="transaction__filter--container d-block bg-white py-2">
      <b-row class="search__export align-items-center mx-0">
        <b-col cols="6" md="6" lg="5">
          <div class="d-flex pl-2">
            <b-img class="filter-image" :class="filter.sort_type == 'asc' ? 'rotate-180' : ''"
              :src="require('@/assets/images/icons/Icon-order-list-down.svg')" alt="Icon-order-list-down" role="button"
              @click="
                filter.sort_type == 'asc'
                  ? (filter.sort_type = 'desc')
                  : (filter.sort_type = 'asc')
                " />
            <div class="search__input w-100 pl-2 pr-0 mr-0">
              <b-input-group>
                <b-form-input v-model="filter.search" placeholder="Cari Billing" />
                <b-input-group-append is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </b-col>
        <b-col cols="6" md="6" lg="7">
          <div class="d-flex justify-content-end" style="gap: 5px">
            <!-- <b-button class="py-1 border-8 font-small-3" @click="extendMainStoreSubscription" v-if="isMainAccount">
              Perpanjang Toko Utama
            </b-button>
            <b-button class="py-1 border-8 font-small-3" @click="addOrExtend('branch')">
              Tambah/Perpanjang Cabang
            </b-button>
            <b-button class="py-1 border-8 font-small-3" @click="addOrExtend('user')">
              Tambah/Perpanjang Pengguna
            </b-button> -->
          </div>
        </b-col>
      </b-row>
    </div>

    <vue-good-table v-if="items" max-height="80vh" :columns="columns" :rows="items" :fixed-header="false" :sort-options="{
      enabled: false
    }" :pagination-options="{
      enabled: false,
    }">
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field == 'action'" />
      </template>
      <template slot="table-row" slot-scope="props">
        <!-- Column: Status -->
        <span v-if="props.column.field === 'xendit_provider.payment_status'">
          <span :class="{
            'badge badge-light-success': props.row.xendit_provider.payment_status === 'success',
            'badge badge-light-warning': props.row.xendit_provider.payment_status === 'pending',
            'badge badge-light-danger': props.row.xendit_provider.payment_status === 'canceled',
            'badge badge-light-secondary': props.row.xendit_provider.payment_status === 'expired',
          }">
            {{
              props.row.xendit_provider.payment_status === 'success' ? 'Sukses' :
                props.row.xendit_provider.payment_status === 'pending' ? 'Menunggu Pembayaran' :
                  props.row.xendit_provider.payment_status === 'canceled' ? 'Dibatalkan' : 'Kedaluwarsa'
            }}
          </span>
        </span>

        <!-- Column Price -->
        <span v-else-if="props.column.field === 'amount'">
          <span>{{ props.row.amount | formatInvoice }}</span>
        </span>
        <span v-else-if="props.column.field === 'total'">
          <span>{{ parseFloat(props.row.total) | formatAmount }}</span>
        </span>

        <!-- Column: Metode Bayar -->
        <span v-else-if="props.column.field === 'payment_method'">
          <span>
            {{
              props.row.payment_method === "qr_code"
                ? "QRIS"
                : props.row.payment_method === "bca_va"
                  ? "BCA Virtual Account"
                  : props.row.payment_method === "bjb_va"
                    ? "BJB Virtual Account"
                    : props.row.payment_method === "bni_va"
                      ? "BNI Virtual Account"
                      : props.row.payment_method === "bri_va"
                        ? "BRI Virtual Account"
                        : props.row.payment_method === "bsi_va"
                          ? "BSI Virtual Account"
                          : props.row.payment_method === "cimb_va"
                            ? "CIMB Virtual Account"
                            : props.row.payment_method === "permata_va"
                              ? "PERMATA Virtual Account"
                              : "MANDIRI Virtual Account"
            }}
          </span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown id="dropdown-dropleft" class="d-flex" right>
              <template #button-content class="btn-white text-center">
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle" />
              </template>
              <b-dropdown-item @click="detailItem(props.row)">
                <span class="pr-5"> Detail Data </span>
              </b-dropdown-item>
              <!-- <b-dropdown-item v-if="props.row.payment_status === 'pending'" @click="cancelOrder(props.row.uuid)">
                <span class="pr-5"> Batalkan Transaksi </span>
              </b-dropdown-item> -->
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>

    <div v-if="rows && isLoading == false"
      class="d-flex justify-content-between align-items-center flex-wrap bg-white border" style="padding: 0.8rem">
      <div class="d-flex align-items-center">
        <b-form-select v-model="filter.per_page" :options="['10', '15', '20']" class="mx-1" />
        <span class="text-nowrap">
          Tampilkan
          {{
            rows.data && rows.data.total > 0
              ? filter.per_page * (rows.data.current_page - 1) + 1
              : 0
          }}
          ke
          {{
            rows.data && rows.data.total > 0
              ? Math.min(
                filter.per_page * rows.data.current_page,
                rows.data.total
              )
              : 0
          }}
          dari {{ rows.data && rows.data.total }} transaksi.
        </span>
      </div>
      <div>
        <b-row class="mx-0 align-items-center">
          <b-col>
            <pagination class="mb-0" :data="rows.data" :limit="4" align="right"
              @pagination-change-page="getListSubscription" />
          </b-col>
        </b-row>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import {
  BRow, BCol, BFormSelect, VBToggle, BFormInput, BInputGroup, BInputGroupAppend, BImg, BButton, BDropdown, BDropdownItem, BSpinner, BModal, VBTooltip, BFormGroup
} from 'bootstrap-vue'
import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
import ModalSubscribe from '../Master/Toko/Modal/ModalSubscribe.vue'
import ModalBillingSubcription from '../Billing/ModalBillingSubcription.vue'

import { VueGoodTable } from 'vue-good-table'
import ModalHeader from '@/components/ModalHeader.vue';
import vSelect from "vue-select";

export default {
  components: {
    VueGoodTable,
    BFormSelect,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BButton,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    ModalSubscribe,
    BSpinner,
    ModalBillingSubcription,
    BModal,
    ModalHeader,
    vSelect,
    BFormGroup
  },
  directives: {
    "b-toggle": VBToggle,
    'b-tooltip': VBTooltip,
  },
  setup() {
    return {
      checkPermission,
      successNotification,
      errorNotification,
    };
  },
  data() {
    const { merchant, branch } = JSON.parse(localStorage.getItem('userData'))
    const { branch_slot, user_slot } = merchant
    const { uuid: branch_uuid, renewal_end_date, is_main_branch } = branch
    return {
      currentPage: 1,
      branch_total_registered: 0,
      branch_slot,
      user_slot,
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "No. Invoice",
          field: "invoice_number",
        },
        {
          label: "Jumlah Kredit",
          field: "amount",
        },
        {
          label: "Total Tagihan",
          field: "total",
        },
        {
          label: "Metode Bayar",
          field: "payment_method",
        },
        {
          label: "Berlaku Hingga",
          field: "xendit_provider.payment_expired_at",
        },
        {
          label: "Status",
          field: "xendit_provider.payment_status",
        },
        {
          label: "Cabang",
          field: "receiver.name",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: {},
      items: [],
      search: "",
      result: {},
      filter: {
        search: "",
        sort_type: "asc",
        per_page: 10,
      },
      isLoading: false,
      subscriptionMethod: '',
      selectedPayment: "",
      paymentList: [],
      minimumTopupCredit: 0,
      transactionFee: 0,
      optionsBranch: [],
      titleDetailInformation: {
        fix_plan: 'Toqoo Fix Plan',
        flex_plan: 'Toqoo Flex Plan'
      },
      typeExtend: '',
      money: {
        decimal: "",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
      creditSubscriptionPayload: {
        amount: 0,
        payment_provider_name: 'xendit',
        payment_method: '',
        receiver_type: 'branch',
        receiver_uuid: ''
      },
      isMainAccount: is_main_branch,
      mainBranchUuid: branch_uuid,
      renewalEndDate: renewal_end_date
    };
  },
  watch: {
    result(value) {
      this.rows = value;
      this.items = value.data.data;
    },
    filter: {
      handler(value) {
        this.$emit("filter", value);
      },
      deep: true,
    },
    filter: {
      handler: _.debounce(function () {
        this.getListSubscription();
      }, 300),
      deep: true,
    },
    creditSubscriptionPayload: {
      handler: _.debounce(function (value) {
        console.log(value, 'VALUE');
      }, 300),
      deep: true
    }
  },
  created() {
    this.getListSubscription();
  },
  mounted() {
    this.handleCta()
    this.getPaymentMethod()
    this.getBranch()
    
    this.$http.get('/settings')
    .then((result) => {
      this.minimumTopupCredit = result.data.data.credit_subscription_minimum_amount 
      this.transactionFee = result.data.data.credit_subscription_transaction_fee
    }).catch((err) => {
      
    });
  },
  methods: {
    extendMainStoreSubscription() {
      this.clearCreditProperty()
      this.$bvModal.show('modal-subscription-method')
    },
    clearCreditProperty() {
      this.subscriptionMethod = ''
      this.typeExtend = ''
      this.creditSubscriptionPayload = {
        amount: 0,
        payment_provider_name: 'xendit',
        payment_method: '',
        receiver_type: 'branch',
        receiver_uuid: ''
      }
    },
    addOrExtend(type) {
      this.clearCreditProperty()
      this.typeExtend = type
      if (type === 'branch') {
        this.$bvModal.show('modal-subscription-method')
      }
      if (type === 'user') {
        this.$bvModal.show('modal-billing-subscription')
      }
    },
    submit() {
      if (this.subscriptionMethod === 'flex_plan') {
        this.$bvModal.show('modal-detail-information')
      }
      if (this.subscriptionMethod === 'fix_plan') {
        if (this.typeExtend === 'branch') {
          this.$bvModal.show('modal-billing-subscription')
        } else {
          this.$bvModal.show('modal-subscribe')
        }
      }
    },
    async getPaymentMethod() {
      try {
        const response = await this.$http.get('/available-payment-methods')
        this.paymentList = response.data.data.map((item) => {
          return {
            name: item.payment_name,
            value: item.payment_code,
            image: item.logo_url,
          }
        })
      } catch (error) {
        
      }
    },
    submitSubscriptionMethod() {
      this.$swal({
        title: `Saat ini Anda masih memiliki langganan Toqoo Fix Plan dengan masa aktif sampai ${this.renewalEndDate}`,
        text: 'Jika proses pembayaran ini dilanjutkan, maka masa aktif Anda di Toqoo Fix Plan akan hangus dan metode berlangganan Anda berubah menjadi Toqoo Flex Plan. \nApakah Anda yakin ingin melanjutkan proses pembayaran ini?',
        icon: 'warning',
        showCancelButton: true,
        width: 600,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
          title: 'text-danger size16 font-weight-bolder'
        },
        buttonsStyling: false,
        color: '#e52a34'
      }).then((result) => {
        console.log(result.isConfirmed, 'RES');
        if (result.isConfirmed) {
          const payload = this.preparePayload()
          this.$http.post('/subscription-credit-payments', payload).then((result) => {
            console.log(result, 'SUKSES');
          }).catch((err) => {
            console.log(err);
          });
        }
      }).catch(err => {
        console.log(err)
      })
    },
    preparePayload() {
      const form = new FormData();
      // isMainAccount
      // mainBranchUuid
      const payload = {
        ...this.creditSubscriptionPayload,
        receiver_uuid: this.isMainAccount && !this.creditSubscriptionPayload.receiver_uuid ? this.mainBranchUuid : this.creditSubscriptionPayload.receiver_uuid?.uuid
      };
      console.log(payload, 'PAYLOAD');
      for (const key in payload) {
        if (payload.hasOwnProperty(key) && payload[key] != null) {
          form.append(key, payload[key]);
          console.log(key, payload[key]);
        }
      }

      return form;
    },
    prevSubmitSubscriptionMethod() {
      console.log('TEST');
      this.$bvModal.hide('modal-detail-information')
    },
    getBranch() {
      this.$store
        .dispatch('cabang/getData', { uuid: '', params: '' })
        .then((result) => {
          this.optionsBranch = result.data.data.data.map((e) => {
            return {
              uuid: e.uuid,
              name: e.name,
              renewal_end_date: e.renewal_end_date
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearchBranch(search, loading) {
      if (search.length) {
        loading(true);
        this.searchUser(loading, search, this);
      } else {
        loading(true);
        setTimeout(() => {
          this.optionsUser = [];
          this.getUser();
          loading(false);
        }, 500);
      }
    },
    searchBranch: _.debounce((loading, search, vm) => {
      vm.$store
        .dispatch('cabang/getData', {
          uuid: '',
          params: {
            search,
          },
        })
        .then((response) => {
          vm.optionsBranch = response.data.data.data.map((e) => {
            return {
              uuid: e.uuid,
              name: e.name,
              renewal_end_date: e.renewal_end_date
            };
          });
          loading(false);
        })
        .catch((error) => {
          loading(false);
        });
    }, 300),
    handleCta() {
      const { cta } = this.$route.query
      if (cta) {
        setTimeout(() => {
          this.$bvModal.show(cta)
        }, 500);
      }
    },
    getFilter(value) {
      this.filter = value;
    },
    async getListSubscription(page = 1) {
      this.isLoading = true;
      const queryParams = this.filter;
      queryParams.page = page;
      this.$http
        .get("/subscription-credit-payments", { params: queryParams })
        .then((result) => {
          this.result = result.data;
          this.currentPage = result.data.data.current_page;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    detailItem(row) {
      const uuid = row.uuid;

      this.$router.push({
        name: 'credit_subscription.detail',
        params: { id: uuid },
      });
    },
    cancelOrder(id) {
      this.$swal({
        title: "Konfirmasi",
        text: "Apa Anda yakin ingin membatalkan transaksi berlangganan ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("subscribe/deleteData", {
              uuid: `${id}`,
            })
            .then(() => {
              this.isLoading = false;
              this.$swal({
                icon: "success",
                title: "Success!",
                text: "Order berhasil dibatalkan",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getListSubscription();
            })
            .catch((err) => {
              this.isLoading = false;
              // eslint-disable-next-line no-console
              console.log(err);
            });
        }
      });
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.vgt-responsive {
  height: calc(100vh - 235px) !important;
  background-color: #fff;
}
</style>